<template>
  <v-container class="main-container" :key="componentKey">
    <div
      v-if="!isHidden"
      class="notification-bar-container"
      :class="'notification-bar-container-' + notificationType"
    >
      <v-layout align-center>
        <div class="vertical-bar"></div>
        <v-icon v-if="icon !== null" class="notification-bar-icon">{{ icon }}</v-icon>
        <span v-html="text" class="notification-bar-text"></span>
        <v-spacer></v-spacer>
        <v-btn icon v-if="secondaryCTAText !== undefined" @click="$emit(secondaryCTAAction)" class="notification-bar-btn notification-bar-btn-secondary">
          <span>{{ secondaryCTAText }}</span>
        </v-btn>
        <v-btn icon v-if="mainCTAText !== undefined" class="notification-bar-btn notification-bar-btn-primary">
          <span>{{ mainCTAText }}</span>
        </v-btn>
      </v-layout>
      <v-progress-linear
        :value="delayValue"
        color="orange"
        height="4"
        class="notification-bar-progress">
      </v-progress-linear>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'notification-bar',
  props: ['icon', 'text', 'mainCTAAction', 'mainCTAText', 'secondaryCTAAction', 'secondaryCTAText', 'notificationType', 'hideNotification', 'componentKey'],
  data () {
    return {
      isHidden: !this.hideNotification,
      delayValue: 0,
      interval: null
    }
  },
  methods: {
    implementDelay () {
      setTimeout(() => {
        this.interval = setInterval(() => {
          if (this.delayValue === 100) {
            this.delayValue = 0
            this.isHidden = true
            return
          }
          this.delayValue += 1
        }, 50)
      }, 3000)
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.isHidden = false
  },
  mounted () {
    this.implementDelay()
  },
  watch: {
    componentKey: function (val, oldVal) {
      if (this.hideNotification === true) {
        setTimeout(() => {
          this.delayValue = 0
          this.isHidden = false
          this.implementDelay()
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  position: relative;
  display: flex;
  justify-content: center;
  min-height: 68px;
  padding-top: 0;
}
.vertical-bar {
  height: 30px;
  width: 2px;
  background-color: #FF9800; // warning-500
  margin: 0 5px
}
.notification-bar {
  &-container {
    position: absolute;
    width: 80%;
    max-width: 35vw;
    top: -25px;
    font-size: 16px;
    border-radius: 6px;
    padding: 0;
    &-warn {
      background-color: #FEE16C; // warning-100
    }
  }
  &-icon {
    color: #021547; // black-900
    margin: 0 10px;
  }
  &-text {
    margin: 10px 0;
  }
  &-btn {
    background-color: #FF9800; // warning-500
    border-radius: $length-med-xs;
    text-transform: capitalize;
    min-width: 80px;
    &-primary {
      background-color: #FF9800; // warning-500
    }
    &-secondary {
      background-color: white;
    }
    &:hover {
      border-radius: $length-med-xs;
    }
  }
  &-progress {
    margin: 0;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/NotificationBar.vue